import {
  Link,
  type TdsLinkProps,
} from '@tallinn-arvudes/ui/tallinn-design/Link';
import { cn } from '@tallinn-arvudes/ui/utils';
import NextLink, { type LinkProps } from 'next/link';
import { type AnchorHTMLAttributes } from 'react';

type CleanedLinkProps = Omit<LinkProps, 'legacyBehavior' | 'passHref'>;

export type TdsNextLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof CleanedLinkProps
> &
  CleanedLinkProps &
  Omit<TdsLinkProps, 'asChild'> & { light?: boolean; noUnderline?: boolean };

export const TdsNextLink = ({
  as,
  children,
  noUnderline,
  replace,
  scroll,
  shallow,
  light,
  className,
  ref,
  ...rest
}: TdsNextLinkProps) => (
  <Link
    ref={ref}
    {...rest}
    className={cn(className, { '!no-underline hover:!underline': noUnderline })}
    light={light}
    renderLink={(props) => {
      return (
        <NextLink
          as={as}
          replace={replace}
          scroll={scroll}
          shallow={shallow}
          {...props}
        >
          {props.children}
        </NextLink>
      );
    }}
  >
    {children}
  </Link>
);
